var React = require('react');

function ChevronUp (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"#20353e","fillRule":"nonzero","stroke":"none","strokeWidth":"1","strokeLinecap":"butt","strokeLinejoin":"miter","strokeMiterlimit":"10","strokeDasharray":"","strokeDashoffset":"0","fontFamily":"none","fontWeight":"none","fontSize":"none","textAnchor":"none","style":{"mixBlendMode":"normal"}},React.createElement("g",{"transform":"translate(-16.64646,16.64844)"},React.createElement("g",null,React.createElement("g",{"transform":"translate(270.08823,242.44333) rotate(-180) scale(4.26667,4.26667)"},React.createElement("g",{"id":"surface1"},React.createElement("path",{"d":"M19.38281,21.44922l11.01563,11.47656l11.01562,-11.47656l3.38672,3.55078l-14.40234,15l-14.39844,-15zM19.38281,21.44922"})))))));
}

ChevronUp.defaultProps = {"version":"1.1","width":"60px","height":"60px","viewBox":"0,0,256,256"};

module.exports = ChevronUp;

ChevronUp.default = ChevronUp;
